import type { ProductBinInfo } from "./bin-selection-modal";

export const getWmsInventoryResolution = (
  lineItems: ProductBinInfo[],
): "bin-selection" | "inventory-adjustment-warning" | null => {
  if (lineItems.length === 0) {
    return null;
  }

  return lineItems.some((item) => item.bins.length > 0)
    ? "bin-selection"
    : "inventory-adjustment-warning";
};
